import Tracked from '~/components/Tracked';
import type { TrackedButtonClickName } from '~/services/gtm.client';

export interface MenuLinkProps {
  link: string;
  onClick?: () => void;
  pagePosition?: string;
  title: string;
  track?: boolean;
}

export default function MenuLink({ title, link, onClick }: MenuLinkProps) {
  return (
    <Tracked.ExternalLink
      href={link}
      name={title as TrackedButtonClickName}
      variant="none"
      className="flex w-fit h-7 border border-grey-divide rounded-full py-1 px-5 text-xs text-black items-center justify-center hover:bg-black hover:text-white hover:border-black"
      pagePosition="Header"
      onClick={onClick}
    >
      {title}
    </Tracked.ExternalLink>
  );
}
